import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientMapping } from "models/client-mapping";

export interface AdminClientMappingSliceState {
    mappings: ClientMapping[];
    editingMapping: ClientMapping | null;
}

export const initialState: AdminClientMappingSliceState = {
    mappings: [],
    editingMapping: null,
};

const byName = (a: ClientMapping, b: ClientMapping) => a.name.localeCompare(b.name);

const AdminClientMappingSlice = createSlice({
    name: "admin-client-mapping-slice",
    initialState,
    reducers: {
        setMappings(state, { payload }: PayloadAction<ClientMapping[]>) {
            state.mappings = [...payload].sort(byName);
        },
        addMapping(state, { payload }: PayloadAction<ClientMapping>) {
            state.mappings = [...state.mappings, payload].sort(byName);
        },
        setMapping(state, { payload }: PayloadAction<ClientMapping>) {
            const index = state.mappings.findIndex(m => m.id === payload.id);
            if (index !== -1) state.mappings[index] = payload;
            state.mappings.sort(byName);
        },
        removeMapping(state, { payload: id }: PayloadAction<string>) {
            state.mappings = state.mappings.filter(m => m.id !== id);
        },
        setEditingMapping(state, { payload }: PayloadAction<ClientMapping | null>) {
            state.editingMapping = payload;
        },
    },
});

export const { setMappings, addMapping, setMapping, removeMapping, setEditingMapping } = AdminClientMappingSlice.actions;

export default AdminClientMappingSlice.reducer;
